var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"content",class:[_vm.className, { content: _vm.content }],style:(Object.assign({}, {width: _vm.w, height: _vm.h, top: _vm.top, left: _vm.left, fontSize: _vm.finalFontSize,
       transform: "translateY(-50%)", backgroundColor: _vm.bg},
       _vm.styles))},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }